import { Directive, input } from '@angular/core';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-light-svg-icons';

/**
 * Standard controller for a header that includes a title and back and forward buttons.
 * If you want different icons, set in your constructor.
 * Add your UI in the player code, or use the provided template.
 * If forward or backlink text is provided, a button should be rendered for the link,
 * else use the forward or backward arrows for the links.
 */
@Directive()
export class V3PageHeaderController {
  public headerTitle = input<string | undefined>(undefined);
  public forwardLink = input<string | string[] | undefined>(undefined);
  public forwardLinkText = input<string | undefined>(undefined);
  public backLink = input<string | string[] | undefined>(undefined);
  public backLinkText = input<string | undefined>(undefined);

  protected faForwardIcon = faArrowRight;
  protected faBackIcon = faArrowLeft;
}
